import { Typography } from "@mui/material";

const CaltexFormTitle = (props) => {
    return (
        <Typography component="h1" sx={{ fontSize: "1.5rem", fontWeight: "500", color: "#004B61" }}>
            {props.children}
        </Typography>
    );
};

export default CaltexFormTitle;
